import * as React from "react";
import { Modal,Button,Input, message} from "antd";
import { connect } from "react-redux";
import { CopyToClipboard } from "react-copy-to-clipboard";

const showMessage = () => {
  message.config({
    duration: 1,
    maxCount: 1
  });
  message.info("复制成功");
};

const style = {
  padding: "0 8px",
  display: "inline-block",
  cursor: "pointer"
};

interface IBuchaProps {
  id:any;
  createLink:any;
}

// 确认函
class Bucha extends React.Component<IBuchaProps, any> {
  state = {
    visible:false,
    fee:'',
    data:'',
  };
  constructor(props: IBuchaProps) {
    super(props);
  }

  handleCancel = () => {
    this.setState({
      visible: false,
    });
  }
  
  show(id) {
    this.setState({
      visible:true
    })
  }

  createLink= () => {
    const param: any = {
      id: this.props.id,
      fee:this.state.fee,
    }; 
    this.props.createLink({
      ...param,
      callback: (data) => {
        this.setState({
          data:data
         })           
      }
     });     
  }

  onChange =(value) => {
    this.setState({
       fee:value.target.value
    })     
  }

  render() {

    return (
      <React.Fragment>
      <Button onClick={this.show.bind(this,this.props.id)}>补差链接</Button> 
      <Modal  maskClosable={false} onCancel={this.handleCancel}  visible={this.state.visible} footer={null} width="auto" centered={true}>
          <div className="bucha">
              <p><label>补差金额：</label><Input onChange={this.onChange}  /></p>
              {this.state.data ? <p>{this.state.data}  <CopyToClipboard text={this.state.data}><div onClick={showMessage} style={style}><i className="action-user action-fuzhi" /></div></CopyToClipboard></p> : ''}
              <div className="down-confirmation">
              <Button type="primary"  onClick={this.createLink} >生成链接</Button>
              </div>
          </div>
      </Modal> 
      </React.Fragment>
    );
  }
}

const mapState = state => ({
  id: state.orderDetails.id,
});

const mapDispatch = dispatch => {
  return {
    createLink: dispatch.orderDetails.createlink
  };
};

export default connect(
  mapState ,
  mapDispatch
)(Bucha);
